// extracted by mini-css-extract-plugin
export default {"auth_container":"styles_auth_container__jprCC"};